var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallestDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 7.3335H6V8.66683H4.66667V7.3335ZM14 4.00016V13.3335C14 14.0668 13.4 14.6668 12.6667 14.6668H3.33333C2.97971 14.6668 2.64057 14.5264 2.39052 14.2763C2.14048 14.0263 2 13.6871 2 13.3335L2.00667 4.00016C2.00667 3.26683 2.59333 2.66683 3.33333 2.66683H4V1.3335H5.33333V2.66683H10.6667V1.3335H12V2.66683H12.6667C13.4 2.66683 14 3.26683 14 4.00016ZM3.33333 5.3335H12.6667V4.00016H3.33333V5.3335ZM12.6667 13.3335V6.66683H3.33333V13.3335H12.6667ZM10 8.66683H11.3333V7.3335H10V8.66683ZM7.33333 8.66683H8.66667V7.3335H7.33333V8.66683Z",
    fill: "#767A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallestDateIcon);
export default __webpack_public_path__ + "static/media/smallest-date-icon.7cbdd8b88db3523cd4dd1cb8382dd5da.svg";
export { ForwardRef as ReactComponent };